import NavBar from "./Components/NavBar";
import Home from "./Components/Home";
import SocialLinks from "./Components/SocialLinks";
import About from "./Components/About";
import Education from "./Components/Education";
import Portfolio from "./Components/Portfolio";
import Contact from "./Components/Contact";

function App() {
  return (
    <div className="relative min-h-screen bg-gray-950 antialiased overflow-x-hidden w-full max-w-full">
      {/* Smooth scrolling wrapper */}
      <div className="relative z-0 w-full max-w-full overflow-x-hidden">
        {/* Navigation - Fixed */}
        <NavBar />
        
        {/* Hero Section */}
        <section className="relative overflow-hidden">
        <Home />
        </section>
        
        {/* Social Links - Fixed on Left (only on larger screens, icons always visible) */}
        <div className="hidden lg:block fixed left-0 top-[35%] z-[60]">
          <SocialLinks />
        </div>
        
        {/* About Section */}
        <section className="relative w-full overflow-x-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>
        <About />
        </section>
        
        {/* Education Section */}
        <section className="relative w-full overflow-x-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-pink-500/30 to-transparent"></div>
          <Education />
        </section>
        
        {/* Projects/Portfolio Section */}
        <section className="relative w-full overflow-x-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent"></div>
        <Portfolio />
        </section>
        
        {/* Contact Section */}
        <section className="relative w-full overflow-x-hidden">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-500/30 to-transparent"></div>
        <Contact />
        </section>
      </div>
    </div>
  );
}

export default App;
